var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1.5V9.75M16.5 7.35V3.9C16.5 3.05992 16.5 2.63988 16.3365 2.31901C16.1927 2.03677 15.9633 1.8073 15.681 1.66349C15.3602 1.5 14.9401 1.5 14.1 1.5H6.08855C4.99244 1.5 4.44438 1.5 4.00173 1.70058C3.61159 1.87735 3.28001 2.16182 3.04597 2.52054C2.78042 2.92755 2.69708 3.46923 2.53041 4.55259L2.1381 7.10259C1.91827 8.53148 1.80836 9.24593 2.02039 9.80184C2.2065 10.2898 2.55653 10.6978 3.01048 10.9559C3.52769 11.25 4.25054 11.25 5.69624 11.25H6.30004C6.72008 11.25 6.9301 11.25 7.09053 11.3317C7.23165 11.4037 7.34639 11.5184 7.41829 11.6595C7.50004 11.8199 7.50004 12.03 7.50004 12.45V14.6506C7.50004 15.672 8.32804 16.5 9.34942 16.5C9.59304 16.5 9.8138 16.3565 9.91275 16.1339L12.4333 10.4626C12.548 10.2047 12.6053 10.0757 12.6959 9.98114C12.776 9.89755 12.8743 9.83363 12.9833 9.79439C13.1065 9.75 13.2476 9.75 13.5299 9.75H14.1C14.9401 9.75 15.3602 9.75 15.681 9.58651C15.9633 9.4427 16.1927 9.21323 16.3365 8.93099C16.5 8.61012 16.5 8.19008 16.5 7.35Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.eaefb85671306140114dd632f78a9051.svg";
export { ForwardRef as ReactComponent };